<template>
  <div>
    <v-row class="rowRecherche">
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-on:input="modifierFiltre"
          clearable
          v-model="filtreObjet.rechercheBarre"
          outlined
          dense
          :label="$t('boutique.filtres.Rechercher')"
          :hide-details="true"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        sm="3"
        md="3"
        lg="3"
      >
        <v-select
          :label="$t('boutique.filtres.NiveauScolaire')"
          :items="itemSelectNiveauScolaireLocal"
          v-on:input="modifierFiltre"
          dense
          outlined
          return-object
          item-text="nom"
          item-value="valeur"
          v-model="filtreObjet.selectNiveauScolaire"
          :hide-details="true"
        >
        </v-select>

      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="3"
        lg="3"
      >
        <v-select
          :label="$t('boutique.filtres.Organisme')"
          v-model="filtreObjet.selectOffreCours"
          v-on:input="modifierFiltre"
          :items="obtenirItemsSelectOffreCours"
          v-on:change="definirLocalStorageCSS"
          :placeholder="$t('boutique.filtres.selectPlaceholder')"
          item-text="nom"
          item-value="cssId"
          return-object
          dense
          outlined
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { NiveauScolaire } from '@/outils/Enum';
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import useInscriptionStore from '@/store/inscriptionStore';

const racineLocalStorage = 'csqc_coursEte';
const cssIdLocaleStorage = '_CSSId';

export default {
  name: 'FilterCoursLigne',
  props: {
    value: Object,
  },
  setup() {
    const inscriptionStore = useInscriptionStore();

    return { inscriptionStore };
  },
  data() {
    return {
      chargement: true,
      filtreObjet: Object,
      itemSelectNiveauScolaireLocal: [
        {
          nom: this.$t('boutique.filtres.SelectNiveauSec1'),
          valeur: NiveauScolaire.SecondaireUn,
        },
        {
          nom: this.$t('boutique.filtres.SelectNiveauSec2'),
          valeur: NiveauScolaire.SecondaireDeux,
        },
        {
          nom: this.$t('boutique.filtres.SelectNiveauSec3'),
          valeur: NiveauScolaire.SecondaireTrois,
        },
        {
          nom: this.$t('boutique.filtres.SelectNiveauSec4'),
          valeur: NiveauScolaire.SecondaireQuatre,
        },
        {
          nom: this.$t('boutique.filtres.SelectNiveauSec5'),
          valeur: NiveauScolaire.SecondaireCinq,
        },
        {
          nom: this.$t('boutique.filtres.SelectNiveauTousNiveaux'),
          valeur: NiveauScolaire.TousLesNiveaux,
        },
      ],
    };
  },
  computed: {
    obtenirItemsSelectOffreCours() {
      return this.inscriptionStore.listeCssMinimise;
    },
    estScolariseMaison() {
      return csqcOutilsCoursEte.EstScolariseMaison();
    },
  },
  methods: {
    modifierFiltre() {
      this.$emit('input', this.infoRechercher);
    },
    async definirLocalStorageCSS() {
      const valeurCssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + cssIdLocaleStorage,
      );

      // Est pas externe
      if (valeurCssIdLocalStorage == null || valeurCssIdLocalStorage === '' || valeurCssIdLocalStorage !== this.filtreObjet.selectOffreCours.cssId) {
        localStorage.setItem(
          racineLocalStorage + cssIdLocaleStorage,
          this.filtreObjet.selectOffreCours.cssId,
        );
        await this.inscriptionStore.definirCoursEnLigne({ cssId: this.filtreObjet.selectOffreCours.cssId, scolariseMaison: this.estScolariseMaison });
      } else {
        // Est externe
        localStorage.setItem(
          racineLocalStorage + cssIdLocaleStorage,
          -1,
        );
        await this.inscriptionStore.definirCoursEnLigne({ cssId: -1, scolariseMaison: this.estScolariseMaison });
      }
    },
  },
  created() {
    this.filtreObjet = this.value;
  },
};
</script>

<style scoped>
.rowRecherche {
  margin-bottom: -45px !important;
}
</style>
